import api from "../../services/axiosConfig";

export const fetchHiveTables = async () => {
  try {
    const response = await api.get("/instances/big-data/hive/list-tables", {
      data: {},
    });
    return response.data.tables.map((tableName) => ({ name: tableName }));
  } catch (error) {
    console.error("Error fetching tables:", error);
    throw error;
  }
};

export const createHiveTable = async (payload) => {
  try {
    const response = await api.post(
      "/instances/big-data/hive/create-table",
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error creating table:", error);
    throw error;
  }
};

export const createHiveTableFromJson = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
      "/instances/big-data/hive/create-table-from-file",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 120000,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error creating table from JSON:", error);
    throw error;
  }
};

export const deleteHiveTable = async (tableName) => {
  try {
    const response = await api.delete(
      `/instances/big-data/hive/delete-table/${tableName}`,
      {
        data: {},
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting table:", error);
    throw error;
  }
};

export const fetchTableDetails = async (tableName) => {
  try {
    const response = await api.get(
      `/instances/big-data/hive/table-details/${tableName}`,
      {
        data: {},
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching table structure:", error);
    throw error;
  }
};
